import React, { memo, useCallback } from 'react';
import { Tabs, NoData } from '@components/index';
import { connect } from 'react-redux';
// import '@style/modules/analysis/analysisRight.scss';
// import '@style/modules/analysis/companyDes.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/companyDes.scss';
import { getValueFromSearchParam, setURLSearchParam } from '@utils/history';
import { useHistory } from 'react-router-dom';
function CompanyOverview({ data = {}, userInfo, isSingleCompany }) {
  const detail = data.cn;
  const { tab: defaultValue } = getValueFromSearchParam('tab');

  const history = useHistory();
  const onTabChange = useCallback((e, tab) => {
    if (tab) {
      setURLSearchParam(history, { tab });
    }
  }, []);

  return (
    <div className="analysis-right-wrapper">
      <div className="title title-no-bottom-border">Company Description</div>
      <Tabs
        isSingleCompany={isSingleCompany}
        defaultValue={defaultValue}
        onChange={onTabChange}
        tabs={
          Array.isArray(detail) &&
          detail.map((curr, i) => ({
            label: curr.companyName || '-',
            children: data.cd[i].longDescription ? (
              <>
                <div className="desContainer">
                  <div
                    className="companyDescrition"
                    // style={{ width: !curr.logo ? '100%' : '60%' }}
                  >
                    {data.cd[i].longDescription}
                  </div>
                  {curr.logo ? (
                    <div className="companyIcon role-control">
                      <img src={curr.logo} alt="" className="companyLogo" />
                    </div>
                  ) : null}
                </div>
                <i className="hint">
                  Due to copyright restrictions, client view does not include
                  company logos
                </i>
              </>
            ) : (
              <NoData />
            ),
          }))
        }
      />
    </div>
  );
}

const mapStateToProps = ({ projects, login, common }) => ({
  userInfo: login.userInfo || {},
  projectId: common.currentId,
});
export default connect(mapStateToProps)(memo(CompanyOverview));
